var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"articles"},[_c('statisticCard',{attrs:{"icon":'mdi-book-open-page-variant',"color":'yellow',"statistic":_vm.statistic.from_start_count,"description":'מאמרים בע״פ'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }